// extracted by mini-css-extract-plugin
export var card = "_o9-0";
export var content = "_o9-2";
export var icon = "_o9-1";